export default {
    // 자동 차감 그룹 목록
    workerCashAutoDeductGroupList: [],
    // 자동 차감 그룹 스케줄 항목 목록
    workerCashAutoDeductGroupOptionList: [],
    isEditWorkerCashAutoDeductGroupDialogOpen: false,
    isEditWorkerCashAutoDeductGroupOptionDialogOpen: false,
    editWorkerCashAutoDeductGroup: {},
    editWorkerCashAutoDeductGroupOption: {},
    selectedWorkerCashAutoDeductGroup: {},
    // 자동 차감 그룹 변경 다이얼로그 전용
    isCashAutoDeductGroupSelectDialogOpen: false,
};
